export const FILTER_TYPE = {
  FIELD: 'fields_filters',
  TAGS: 'tags',
  META_DATA: 'meta_data_fields',
  STATUS: 'status',
}
